import { makeAutoObservable, observable } from 'mobx';

/**
 * @typedef {EN.Line} default
 */
export class Line {
  /**
   * @param {EN.Line} model
   */
  constructor(model) {
    makeAutoObservable(this);

    /** @type {EN.Line['id']} */
    this.id = '';
    /** @type {EN.Line['lid']} */
    this.lid = '';
    /** @type {EN.Line['isUnsubscribed']} */
    this.isUnsubscribed = false;

    Object.assign(this, model);
  }

  disciplineIds = [];

  update(data) {
    Object.assign(this, data);
  }
}
